import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import ProductList from '../ProductList/ProductList';
import classes from './Category.module.css';

class Category extends Component {
    componentDidMount() {
        this.props.resetFilter();
        window.scrollTo(0, 0);
        
    }

    componentDidUpdate(prevProps, prevState) {
        window.scrollTo(0, 0);
    }
    
    
    render(){
        const index = parseInt(this.props.match.params.id);
        const catIndex = this.props.getCategory(index);
        const cat = this.props.categories[catIndex];
        const products = this.props.getProducts(index);
        console.log("category");
        console.log(this.props);
        
        
        let cat_filters = null;
        if (cat.hasOwnProperty('cat_filters')){
            cat_filters = 
                <div className={classes.CategoryFilters}>
                    
                    <ul> 
                        {cat.cat_filters.map(filter => 
                            <li 
                                onClick={(f) => this.props.setFilter(filter)}
                                className={this.props.filter === filter ? "active" : null}
                                key={filter}>
                                    {filter}
                            </li>)}
                    </ul>
                </div>
        }

        let topNavigation = (
            <div className={classes.TopNavigation}>
                <Link to='/Menu'>
                    <button><i class="fas fa-arrow-left"></i></button>   
                </Link>
            </div>
        );
        
        
        
        return (
            <div className={classes.Category}>
                {topNavigation}
                <h2 >{cat.name[0]}</h2> 
                <div className="filters-wrapper">
                    <div className="filters">
                        {cat_filters}
                    </div> 
                </div>
                {cat.hasOwnProperty('header') 
                    ?   <div className={classes.CategoryHeader}>
                            {cat.header}
                        </div> 
                    :   null}

                <ProductList 
                    setFilter = {(filter) => this.props.setFilter(filter)}
                    filter = {this.props.filter}
                    products={products}
                    hidePrice={cat.hasOwnProperty("hidePrice")}/> 

                <div className="filters-wrapper">
                    <div className="filters">
                        {cat_filters}
                    </div> 
                </div>    

                {cat.hasOwnProperty('preFooter') 
                    ?   <div className={classes.CategoryPreFooter}>
                            {cat.preFooter}
                        </div> 
                    :   null}
                {cat.hasOwnProperty('footer') 
                    ?   <div className={classes.CategoryFooter}>
                            {cat.footer}
                        </div> 
                    :   null}
                

                <aside>
                    <p>Στις τιμές συμπεριλαμβάνονται όλοι οι νόμιμοι φόροι.</p>
                    <p>Ο καταναλωτής δεν έχει υποχρέωση να πληρώσει εάν δεν λάβει το Νόμιμο παραστατικό στοιχείο (Απόδειξη ή Τιμολόγιο))</p>
                </aside>
                    
                <div className={classes.Back} >
                    <Link to='/Menu'>
                        Επιστροφή στο κεντρικό μενού
                    </Link>
                </div>  
            </div>
        )
   }
}

export default Category;
